import { IApiResult } from 'src/generated-types/api-result'
import { IExpandGrid, IGridExpansionPreview, IGridSide } from 'src/generated-types/grid-expansion'
import { IOlexMatchPreview } from 'src/generated-types/olex-match'
import { useGet, usePost, usePut } from './reactQuery'
import { projectEndpoints } from './project'

const positionsUrl = (customerId: EntityId, localityId: EntityId, projectId: EntityId) =>
  projectEndpoints.projectVersionPositions(customerId, localityId, projectId)

export const useUpdatePositionCoordinates = (customerId: EntityId, localityId: EntityId, projectId: EntityId) =>
  usePut<IApiResult, { positionId: number; latitude: number; longitude: number }>(
    `${positionsUrl(customerId, localityId, projectId)}/coordinates`,
  )

export const useRevertPosition = (customerId: EntityId, localityId: EntityId, projectId: EntityId) =>
  usePost<IApiResult, { positionId: number }>(`${positionsUrl(customerId, localityId, projectId)}/revert`)

export const useRestorePosition = (customerId: EntityId, localityId: EntityId, projectId: EntityId) =>
  usePost<IApiResult, { name: string }>(`${positionsUrl(customerId, localityId, projectId)}/restore`)

export const useAddLine = (customerId: EntityId, localityId: EntityId, projectId: EntityId) =>
  usePost<IApiResult, { cornerPositionId: number }>(`${positionsUrl(customerId, localityId, projectId)}/add-line`)

export const useExpandGrid = (customerId: EntityId, localityId: EntityId, projectId: EntityId) =>
  usePost<IApiResult, IExpandGrid>(`${positionsUrl(customerId, localityId, projectId)}/expand-grid`)

// Both take the Olex file as form data under "file".
export const usePreviewOlexMatch = (customerId: EntityId, localityId: EntityId, projectId: EntityId) =>
  usePost<IOlexMatchPreview, FormData>(`${positionsUrl(customerId, localityId, projectId)}/olex/preview`)

export const useApplyOlexMatch = (customerId: EntityId, localityId: EntityId, projectId: EntityId) =>
  usePost<IApiResult, FormData>(`${positionsUrl(customerId, localityId, projectId)}/olex`)

export const useGetGridExpansionPreview = (
  customerId: EntityId,
  localityId: EntityId,
  projectId: EntityId,
  side: IGridSide,
  count: number,
) =>
  useGet<IGridExpansionPreview>(
    `${positionsUrl(customerId, localityId, projectId)}/expand-grid`,
    { side, count },
    { refetchOnMount: 'always', keepPreviousData: true },
  )
